// 'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UIPopoverBody from 'UIComponents/tooltip/UIPopoverBody';
import UIPopoverFooter from 'UIComponents/tooltip/UIPopoverFooter';
import UIPopoverHeader from 'UIComponents/tooltip/UIPopoverHeader';
import { forwardRef, useCallback, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DocumentPreviewForm = /*#__PURE__*/forwardRef(({
  previewTitle,
  previewDescription,
  onCancel,
  onConfirm
}, ref) => {
  const [title, setTitle] = useState(previewTitle);
  const [description, setDescription] = useState(previewDescription);
  const cancelOrConfirmKeys = useCallback(e => {
    switch (e.key) {
      case 'Escape':
        {
          e.preventDefault();
          onCancel();
          return;
        }
      case 'Enter':
        {
          e.preventDefault();
          onConfirm({
            title,
            desc: description
          });
          return;
        }
      default:
        return;
    }
  }, [description, onCancel, onConfirm, title]);
  const inputHasNotChanged = title === previewTitle && description === previewDescription;
  const disabled = title === '' || inputHasNotChanged;
  return /*#__PURE__*/_jsxs("div", {
    style: {
      width: 300
    },
    ref: ref,
    children: [/*#__PURE__*/_jsx(UIPopoverHeader, {
      children: /*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.documents.editPopover.title"
        })
      })
    }), /*#__PURE__*/_jsxs(UIPopoverBody, {
      children: [/*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.documents.editPopover.previewTitle"
        }),
        className: "p-top-0",
        children: /*#__PURE__*/_jsx(UITextInput, {
          onChange: ({
            target: {
              value
            }
          }) => {
            setTitle(value);
          },
          onKeyDown: cancelOrConfirmKeys,
          value: title
        })
      }), /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.documents.editPopover.previewDescription"
        }),
        className: "p-top-0",
        children: /*#__PURE__*/_jsx(UITextInput, {
          onChange: ({
            target: {
              value
            }
          }) => {
            setDescription(value);
          },
          onKeyDown: cancelOrConfirmKeys,
          value: description
        })
      })]
    }), /*#__PURE__*/_jsxs(UIPopoverFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "tertiary",
        size: "small",
        onClick: () => onConfirm({
          title,
          desc: description
        }),
        disabled: disabled,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.documents.editPopover.save"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary-light",
        size: "small",
        onClick: onCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.documents.editPopover.cancel"
        })
      })]
    })]
  });
});
export default DocumentPreviewForm;